<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="所属区域">
              <Cascader
                v-model="comList"
                :data="communityList"
                placeholder="请选择"
                clearable
                @on-change="communityChange"
                change-on-select
              ></Cascader>
            </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="注册时间" prop="updateTime">
                <DatePicker type="datetime" v-model="time"></DatePicker>
              </form-item>
            </i-col>
           </row>
        </i-form>

      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader2"
            :border="true"
            :loading="isLoading"
            :data="tableData2"
            stripe
            ref="table"
          >
            <!-- <template slot-scope="{ row, index }" slot="action2"> -->
              <!-- <span class="action">[删除]</span> -->
              <!-- <span class="action"  @click="handleschoolDetail(row)">[查看]</span> -->
              <!-- <span @click.stop="handleClickDetail(row, 'detail')" class="action">[详情]</span> -->
            <!-- </template> -->

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total2"
            :current="pageNum2"
            @on-change="pageChange2"
            show-total
          />
        </div>
      </div>



    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import store from "../../../store/index";
import api from "../../../api/index";
const {
  realName,
  realUpData
} = api;

export default {
  name: "schoollist",
  components: {
    pageHead
  },

  data() {
    return {
      btnList: [
        {name: "查询",type: "search"},
        {name: "重置",type: "refresh"},
          {
          name: "导出",
          type: "export"
        }
      ],
      iseducation:false,
      modal1:false,
      tapidnex:3,
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      communityList: [],
      deptNamelist:[],
      deptNamelist1:[],
      comList:[],
      time:'',
      query: {
           "path": '',
           "updateTime": "",
      },


      shoolquery:{
        schoolId:''
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum2: 1,
      pageSize2: 10,
      total2: 0,
      title: "实名认证",
      tableHeader2: [
        // {type: "selection",width:70,align: "center",},
        // {title: "序号",key: "id",width:100,},
        {title: "姓名",key: "name"},
        {title: "证件号",key: "cardno"},
        {title: "注册日期",key: "createTime"},
        {title: "社区名称",key: "communityName"},
      ],
      tableHeader3: [
        {title: "教育局序号",key: "id",width:90,},
        {title: "教育局名称",key: "schoolName",width:220},
        {title: "行政区域",key: "schoolRegion",},
        {title: "教育局地丘号",key: "schoolLandNum",},
        {title: "关联部门",key: "deptName",},
        {title: "教育局地址",key: "schoolAddress",},
        {title: "描述",key: "schoolInfo",},
        {title: "操作",slot: "action3",minWidth:46,},
      ],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      selectedList: [],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    communityChange(value) {
    // console.log(value)
    let returndata = value[value.length - 1];
    this.query.path = returndata.communityId;
    console.log(this.query.path);
  },
    getCommunity() {
    this.$get(this.urlobj.getCommunityCascade, {
      communityId: this.$store.state.streetorcommunityid,
      nationwide: 1,
      lowestLevelId: 10000007770009
    })
      .then(res => {
        console.log(res)
        this.communityList = res.rows.length
          ? this.formateData(res.rows)
          : [];
        console.log(this.communityList);
      })
      .catch(e => {
        this.$Message.error("获取行政区域失败");
      });
  },
  formateData(data) {
    let returnData = data.map(item => {
      return {
        value: {
          communityId: item.communityId,
          childrenIdList: item.childrenIdList
        },
        label: item.communityName,
        children: item.children.length ? this.formateData(item.children) : []
      };
    });
    return returnData;
  },
    handleBtn(type){
      if (type == "search") {
        this.pageNum2 = 1;
        this.getLandTransferList2();
      }else  if (type == "refresh") {
        this.pageNum2 = 1;
        this.comList = [];
        this.time = '';
        this.query={
         "path": '',
         "updateTime": "",
        }
        this.getLandTransferList2();
        }else {
          let {path,updateTime} = this.query
          let url = `${realUpData}?path=${path}&updateTime=${updateTime}&token=${this.header.token}` ;
          window.open(url);

      }
    },
    pageChange2(val) {
      this.pageNum2 = val;
      this.getLandTransferList2();
    },

    async getLandTransferList2() {
      if(this.time){
        this.query.updateTime = this.$util.FormatDate(
          new Date(this.time),
          "yyyy-MM-dd HH:mm:ss"
        );
      }
      this.isLoading = true;
      let data={
        pageNum:this.pageNum2,
        pageSize:this.pageSize2,
        ...this.query
      }
      try {
        console.log(realName)
        this.$post(realName,{
            pageNum:this.pageNum2,
            pageSize:this.pageSize2,
            ...this.query})
          .then(res => {
            if(res.code == 1){
                this.tableData2 = res.rows;
                this.total2 = res.total;
            } else {
                this.$Message.error(res.message);
            }
          })
          .catch(e => {
            this.$Message.error("获取列表失败");
          });
      } finally {
        this.isLoading = false;
      }
    },
    
  },

  created() {
    this.getLandTransferList2()
    this.getCommunity();
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  min-height: calc(100vh - 320px);
  .page {width: 100%;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
